// extracted by mini-css-extract-plugin
export default {"title":"OnlineRatioAxis_title__HIwco"};